// ORACURA: Cal.com bookings, listed per event type (see BookingsView.vue).
import {
  CONVERSATION_PERMISSIONS,
  ROLES,
} from 'dashboard/constants/permissions';
import { frontendURL } from '../../../helper/URLHelper';
import BookingsView from './BookingsView.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/bookings/:kind'),
    name: 'oracura_bookings',
    component: BookingsView,
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
    },
  },
];
